export default function () {
    return {
        ET: {
            Jaanuar: '01',
            Veebruar: '02',
            Märts: '03',
            Aprill: '04',
            Mai: '05',
            Juuni: '06',
            Juuli: '07',
            August: '08',
            September: '09',
            Oktoober: '10',
            November: '11',
            Detsember: '12'
        },
        EN: {
            January: '01',
            February: '02',
            March: '03',
            April: '04',
            May: '05',
            June: '06',
            July: '07',
            August: '08',
            September: '09',
            October: '10',
            November: '11',
            December: '12'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/date/index.js